<template>
  <TreeSelect
    style="width: 100%"
    ref="treeSelect"
    :apiUrl="apiUrl"
    :apiData="apiData"
    clearable
    :multiple="multiple"
    v-bind="$attrs"
    v-on="$listeners"
    @setSearchModal="setSearchModalHandler"
    returnType="xx"
  ></TreeSelect>
</template>

<script>
  import { mapState } from 'vuex';
  import TreeSelect from '@/components/form-item/tree-select';
  import BASE_API from '@/api/dataBase';
  export default {
    name: 'BOrganizationTree',
    props: {
      multiple: {
        type: Boolean,
        default: false,
      },
      value: {
        required: true,
      },
    },
    data() {
      return {
        apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
      };
    },
    methods: {
      setSearchModalHandler(mod, obj) {
        console.log(mod, '切换', obj);
        this.$emit('setSearchModalHandler', obj);
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      apiData() {
        return {
          tenantCode: this.userInfo.tenantCode,
          adminFlag: this.userInfo.adminFlag,
          selfCompanyDepartmentTreeFlag: true,
        };
      },
    },
    components: {
      TreeSelect,
    },
  };
</script>

<style lang="scss" scoped>
  ::v-deep .vue-treeselect__multi-value-item {
    border: none !important;
    padding: 0 !important;
  }
  ::v-deep .vue-treeselect__placeholder {
    height: 28px !important;
    font-size: 13px !important;
    line-height: 28px !important;
  }
  ::v-deep .vue-treeselect__input-container {
    padding-top: 0 !important;
    height: 28px !important;
  }
  ::v-deep .vue-treeselect__multi-value-item-container {
    padding-top: 0 !important;
  }
  ::v-deep .vue-treeselect__multi-value {
    margin-bottom: 0 !important;
  }
  ::v-deep .vue-treeselect__control {
    height: 30px !important;
  }
  ::v-deep .el-form-item__content div {
    height: auto !important;
  }
  ::v-deep .vue-treeselect__single-value {
    line-height: 28px !important;
    font-size: 13px !important;
  }
</style>
